"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RenderReason;
(function (RenderReason) {
    RenderReason["INITIAL"] = "INITIAL";
    RenderReason["STATE_CHANGE"] = "STATE_CHANGE";
    RenderReason["STORE_CHANGE"] = "STORE_CHANGE";
    RenderReason["ATTRIBUTE_CHANGE"] = "ATTRIBUTE_CHANGE";
    RenderReason["THEME_CHANGE"] = "THEME_CHANGE";
    RenderReason["CHILDREN_UPDATE"] = "CHILDREN_UPDATE";
})(RenderReason = exports.RenderReason || (exports.RenderReason = {}));
//# sourceMappingURL=irender-reason.js.map